// extracted by mini-css-extract-plugin
export default {"dialogHeaderContainer":"SignedCommitDialog-module__dialogHeaderContainer--Uo1Kc","signatureLinkContent":"SignedCommitDialog-module__signatureLinkContent--l9xs2"};